module.exports = __webpack_public_path__ + "static/media/bangle.9aafccfd.png";